export default "__VITE_ASSET__9e33d20e__"